import { render, staticRenderFns } from "./TheMovies.vue?vue&type=template&id=eb8f18da&scoped=true&"
import script from "./TheMovies.vue?vue&type=script&lang=coffee&"
export * from "./TheMovies.vue?vue&type=script&lang=coffee&"
import style0 from "./TheMovies.vue?vue&type=style&index=0&id=eb8f18da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8f18da",
  null
  
)

export default component.exports